export const EVENT_SESSION_EXPIRED = 'SESSION_EXPIRED';
